export enum Experiments {
  USE_REQ_QUERY_LOCALE = 'specs.membersArea.UseReqQueryLocale',
  SHOW_MORE_MEMBERS_WITH_BADGE = 'specs.membersArea.ShowMoreMembersWithBadge',
  DO_NOT_CREATE_TEAM_MEMBER = 'specs.membersArea.DoNotCreateTeamMember',
  CALL_GET_MY_MEMBER_FOR_CREATING_MEMBER = 'specs.membersArea.CallGetMyMemberForCreatingMember',
  NEW_APP_SETTINGS_SERVICE = 'specs.membersArea.NewAppSettingsService',
  NEW_APP_SETTINGS_SERVICE_READ = 'specs.membersArea.NewAppSettingsRead',
  BLOG_GUEST_WRITER = 'specs.membersArea.BlogGuestWriter',
  CHECK_CONTRIBUTOR_PERMISSIONS = 'specs.membersArea.CheckUserContributorPermissions',
  MEMBERS_ROLES_USE_MEMBERS_ROLES_API = 'specs.membersArea.UseMembersRoles',
  USE_FOLLOWERS_V3 = 'specs.membersArea.UseFollowersV3',
  USE_QUERY_MEMBERS_TEXT_SEARCH = 'specs.membersArea.UseQueryMembersTextSearch',
  MEMBER_SERVICE_GET_FROM_MEMBERS_NG_API = 'specs.membersArea.MemberServiceGetFromMembersNgApi',
  USE_REAL_SITE_MEMBER_ID = 'specs.membersArea.UseRealSiteMemberId',
  HIDE_SUSPENDED_LABEL_FOR_NON_OWNERS = 'specs.membersArea.HideSuspendedLabelForNonOwners',
  HIDE_SUSPENDED_LABEL_FOR_NON_OWNERS_FF_BOX = 'specs.membersArea.HideSuspendedLabelForNonOwnersFFBox',
  USE_POPOVER_DYNAMIC_POSITIONING = 'specs.membersArea.UsePopoverDynamicPositioning',
  CREATE_MISSING_MEMBER = 'specs.membersArea.CreateMissingMember',
  USE_GET_MY_MEMBER_IN_MEMBER_HANDLER = 'specs.membersArea.UseGetMyMemberInMemberHandler',
  HIDE_MEMBER_SORT_FIELD = 'specs.membersArea.HideMemberSortField',
  USE_IS_PERMITTED_ON_MEDIA_CREDENTIALS = 'specs.membersArea.UseIsPermittedOnMediaCredentials',
  SHOW_NEW_FF_BORDER_SETTINGS = 'specs.membersArea.ShowNewFFBorderSettings',
  USE_VIEWED_MEMBER_BLOCKED = 'specs.membersArea.UseViewedMemberBlocked',
  HIDE_WRITER_ACTIONS_IN_VIEWER = 'specs.wixBlog.MAHideWriterActionsInViewer',
  SHOW_CASCADING_INDICATORS = 'specs.membersArea.showCascadingIndicators',
  SHOW_TABS_IN_BUTTON_SETTINGS = 'specs.membersArea.ShowTabsInButtonSettings',
}
